import { BookOpen, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { articles } from '../data/articles';

export const ArticulosPage = () => {
  return (
    <div className="pt-20" data-testid="articulos-page">
      {/* Hero Section */}
      <section className="py-20 md:py-28 bg-gradient-to-br from-[#43b6b8] to-[#359a9c]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6">
            Artículos
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Recursos educativos y perspectivas sobre el desarrollo cognitivo y académico de los niños.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20 md:py-28" data-testid="articles-list">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {articles.map((article) => (
              <article
                key={article.id}
                className="bg-white rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] card-hover flex flex-col"
                data-testid={`article-${article.id}`}
              >
                <Link
                  to={`/articulos/${article.slug}`}
                  className="block aspect-[4/3] overflow-hidden bg-stone-100 group"
                  data-testid={`article-image-link-${article.id}`}
                  aria-label={`Leer artículo: ${article.title}`}
                >
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700 ease-out"
                    style={{ objectPosition: 'center top' }}
                    loading="lazy"
                  />
                </Link>
                <div className="p-8 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <BookOpen className="w-5 h-5 text-[#43b6b8]" />
                    <span className="text-sm text-stone-600">{article.dateShort}</span>
                  </div>
                  <h2 className="text-2xl font-semibold text-stone-900 mb-4">
                    <Link
                      to={`/articulos/${article.slug}`}
                      className="hover:text-[#43b6b8] transition-colors"
                      data-testid={`article-title-link-${article.id}`}
                    >
                      {article.title}
                    </Link>
                  </h2>
                  <p className="text-sm text-stone-600 mb-4">Por {article.author}</p>
                  <p className="text-base text-stone-700 leading-relaxed mb-6 flex-1">
                    {article.summary}
                  </p>
                  <Link
                    to={`/articulos/${article.slug}`}
                    className="inline-flex items-center gap-2 text-[#43b6b8] font-semibold hover:gap-3 transition-all self-start"
                    data-testid={`read-more-${article.id}`}
                  >
                    Leer más <ArrowRight className="w-5 h-5" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* About Author Section */}
      <section className="py-20 md:py-28 bg-[#F3F0EA]" data-testid="about-author">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <div className="flex items-start gap-6 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/e107zbnp_PHOTO-2026-04-15-20-56-21.jpg"
                alt="Doctora Melissa Núñez Robles"
                className="w-24 h-24 rounded-full object-cover ring-2 ring-[#d3b163]/40"
                style={{ objectPosition: '65% 30%' }}
              />
              <div>
                <h3 className="text-xl font-semibold text-stone-900 mb-2">Dra. Melissa Núñez Robles</h3>
                <p className="text-sm text-stone-600">
                  Fundadora y Directora de Rise & Shine Learning Zone
                </p>
              </div>
            </div>
            <p className="text-base text-stone-700 leading-relaxed">
              Educadora con más de 17 años de experiencia, certificada en autismo y neurociencia cognitiva aplicada a la educación. Doctora en Educación Especial especializada en intervención temprana para niños dentro del espectro autista.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#43b6b8]" data-testid="articulos-cta">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            ¿Necesitas orientación personalizada?
          </h2>
          <p className="text-lg text-white/95 mb-8">
            Descubre cómo nuestros servicios de consultoría pueden apoyar el desarrollo de tu hijo.
          </p>
          <a
            href="/informacion-admision"
            className="inline-block bg-[#d3b163] hover:bg-[#b89548] text-white px-8 py-4 rounded-full font-semibold transition-all active:scale-95"
          >
            Solicita Información
          </a>
        </div>
      </section>
    </div>
  );
};
